import {createContext, useContext, useState} from "react";

const ProductFlowContext = createContext();
export const ProductFlowProvider = ({ children }) => {
    const [onNext, setOnNext] = useState(undefined);

    const [selectedProduct, setSelectedProduct] = useState(undefined);

    const resetFlow = () =>{
        setOnNext(undefined);
        setSelectedProduct(undefined)
    }
    return (
        <ProductFlowContext.Provider
            value={{
                onNext, setOnNext,
                selectedProduct, setSelectedProduct,
                resetFlow
            }}>
            {children}
        </ProductFlowContext.Provider>
    )
}

export const useProductFlowContext = () => useContext(ProductFlowContext);
